import { signalStore, withState } from '@ngrx/signals';
import { initialPayrollState } from './payroll.state';
import { withPayrollApiMethods } from './payroll.methods.api';

export const PayrollStore = signalStore(
  { providedIn: 'root' },
  withState(initialPayrollState),
  withPayrollApiMethods
);
